// Module
var code = "<saml-settings></saml-settings> ";
// Exports
module.exports = code;